import api from '~api'
import moment from 'moment'

import {
  convertCampusRecruitingIndexResponse,
  convertPages,
  convertMedia,
  convertCampusRecruitingDetailsBasicInfo,
  converCampusRecruitingDetailsEnrolledAdvertisements
} from '~utils/api'

export const url = `/school-hire`

export async function getCampusRecruitments(params) {
  const {
    data
  } = await api.get(`${url}`, { params })

  const recruitments = data.data.map(recruitment => {
    return convertCampusRecruitingIndexResponse(recruitment)
  })

  const pages = convertPages(data.meta)
  return { recruitments, pages }
}

export async function getCampusRecruitmentById(id) {
  const {
    data
  } = await api.get(`${url}/${id}`)
  const response = data.data
  const basicInfo = convertCampusRecruitingDetailsBasicInfo(response)
  const advertisements = converCampusRecruitingDetailsEnrolledAdvertisements(response.enlistCommodities)
  const orientationInfo = {
    orientation_title: response.enlistSeminar.name,
    orientation_start_date: response.enlistSeminar.start_date,
    orientation_end_date: response.enlistSeminar.end_date,
    orientation_charge: response.enlistSeminar.price,
    orientation_content: response.enlistSeminar.content,
    orientation_attachments: convertMedia(response.enlistSeminar.media).length ? convertMedia(response.enlistSeminar.media)[0] : null
  }
  const expoInfo = {
    expo_title: response.enlistExposition.name,
    expo_enrollment_start_date: response.enlistExposition.booth_start_date,
    expo_enrollment_end_date: response.enlistExposition.booth_end_date,
    expo_start_time: response.enlistExposition.start_date,
    expo_end_time: response.enlistExposition.end_date,
    expo_booth_charge: response.enlistExposition.price,
    expo_content: response.enlistExposition.content,
    earliest_booth_time: response.enlistExposition.earliest_booth_time || '',
    expo_attachments: convertMedia(response.enlistExposition.media).length
      ? convertMedia(response.enlistExposition.media)
      : null
  }
  return {
    basicInfo,
    advertisements,
    orientationInfo,
    expoInfo
  }
}

export async function getOrientationsById(id) {
  const {
    data
  } = await api.get(`${url}/${id}/enlistSeminarDates`)

  const orientations = data.data.map(orientation => {
    const activeDate = moment(orientation.seminar_date).format('YYYY/MM/DD')
    const orientationDate = {
      orientation_date_id: orientation.id,
      orientation_date: activeDate,
      orientation_number: orientation.enlistSeminarSessions.length
    }

    const slots = orientation.enlistSeminarSessions.map(slot => {
      const hasBooked = Object.keys(slot).includes('enlistForms') && slot.enlistForms.length
      const currentSlot = {
        orientation_time_slot_id: slot.id,
        orientation_date: activeDate,
        orientation_start_time: slot.start_date,
        orientation_end_time: slot.end_date,
        duration: `${moment(`${activeDate} ${slot.start_date}`).format('HH:mm')}~${moment(`${activeDate} ${slot.end_date}`).format('HH:mm')}`,
        has_booked: Boolean(hasBooked),
        enterprise_gui_number: hasBooked ? slot.enlistForms[0].enterprise.account : '',
        enterprise_name: hasBooked ? slot.enlistForms[0].enterprise.name : ''
      }
      return currentSlot
    })

    orientationDate.orientation_time_slots = slots
    orientationDate.orientation_date_has_space = slots.filter((slot) => slot.has_booked).length < orientation.enlistSeminarSessions.length
    return orientationDate
  })

  return orientations
}

export async function getExpoById({ id, page }) {
  const {
    data
  } = await api.get(`${url}/${id}/enlistExposition`, {
    params: {
      page
    }
  })
  const response = data.data
  let booths = {}

  Object.keys(response.enterprises).forEach(index => {
    const booth = response.enterprises[index]
    booths[`${booth.booth_number}`] = {
      booth_id: booth.id,
      booth_number: booth.booth_number,
      booth_enterprise_id: booth.account,
      booth_company_name: booth.name || '無名氏',
      booth_name: booth.booth_name
    }
  })
  const pages = convertPages(data.meta)

  return {
    expo: {
      expo_total_booth_number: response.booth_total,
      expo_content: response.booth_content,
      expo_booths: booths,
      expo_enrollment_start_date: response.booth_start_date,
      expo_enrollment_end_date: response.booth_end_date,
      expo_enrollment_available: response.booth_enable
    },
    pages
  }
}
